import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { selectActivePrivacyStatementUrl, selectActiveTermsOfUseUrl } from '../../redux/config/selectors';
import { Button, Modal } from '../ui';
import { AuthenticationLayout } from '../../containers/Layout/AuthenticationLayout';
import { approveTermsOfUse } from '../../redux/authentication/slice';

const OptInModalContent = styled.div`
  color: var(--greyscale-blackish);
  font-size: var(--font-size-regular);
  line-height: var(--font-line-height-regular);
`;

const OptInModalContentHyperLink = styled.a`
  color: var(--primary-oqio-blue);
  cursor: pointer;
  display: inline-block;
  text-decoration: underline;

  &:focus {
    outline: none;
  }

  :hover {
    color: var(--primary-oqio-blue);
  }
`;

const ApproveTermsOfUseModalComponent = ({
  config,
  currentUser,
  approveTermsOfUse,
  approveTermsOfUseLoading,
  activePrivacyStatementUrl,
  activeTermsOfUseUrl
}) => {
  const handleConfirmOptIn = () => {
    if (approveTermsOfUseLoading) {
      return;
    }
    approveTermsOfUse({ userId: currentUser.id });
  };

  const footer = (
    <Button onClick={handleConfirmOptIn} type="primary">
      Zustimmen
    </Button>
  );

  return (
    <AuthenticationLayout hideLinks config={config}>
      <Modal
        closable={false}
        footer={footer}
        style={{ top: 250 }}
        mask={false}
        title="Nutzungsbedingungen & Datenschutzerklärung"
        width={700}
        open
        createNoPointerEventsContainer
      >
        <OptInModalContent>
          Bitte stimmen Sie den aktualisierten&nbsp;
          <OptInModalContentHyperLink href={activeTermsOfUseUrl} target={'_blank'} rel="noopener noreferrer">
            Nutzungsbedingungen
          </OptInModalContentHyperLink>
          &nbsp;und&nbsp;
          <OptInModalContentHyperLink
            className="link"
            href={activePrivacyStatementUrl}
            target={'_blank'}
            rel="noopener noreferrer"
          >
            Datenschutzerklärung
          </OptInModalContentHyperLink>
          &nbsp;zu.
        </OptInModalContent>
      </Modal>
    </AuthenticationLayout>
  );
};

const mapStateToProps = (state) => ({
  activePrivacyStatementUrl: selectActivePrivacyStatementUrl(state),
  activeTermsOfUseUrl: selectActiveTermsOfUseUrl(state)
});

const mapDispatchToProps = {
  approveTermsOfUse
};

export const ApproveTermsOfUseModal = connect(mapStateToProps, mapDispatchToProps)(ApproveTermsOfUseModalComponent);
